var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Info = function (_a) {
    var props = __rest(_a, []);
    return (_jsxs("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_2_132)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.91667C17.0166 2.91667 21.0833 6.98341 21.0833 12C21.0833 17.0166 17.0166 21.0833 12 21.0833C6.98343 21.0833 2.91668 17.0166 2.91668 12C2.91668 6.98341 6.98343 2.91666 12 2.91667ZM23.0833 12C23.0833 5.87884 18.1212 0.916666 12 0.916665C5.87886 0.916665 0.916683 5.87884 0.916682 12C0.916682 18.1211 5.87886 23.0833 12 23.0833C18.1212 23.0833 23.0833 18.1212 23.0833 12ZM12 10.0833C11.4477 10.0833 11 10.531 11 11.0833L11 16.5833C11 17.1356 11.4477 17.5833 12 17.5833C12.5523 17.5833 13 17.1356 13 16.5833L13 11.0833C13 10.531 12.5523 10.0833 12 10.0833ZM12 9.25C11.2406 9.25 10.625 8.63439 10.625 7.875C10.625 7.11561 11.2406 6.5 12 6.5C12.7594 6.5 13.375 7.11561 13.375 7.875C13.375 8.63439 12.7594 9.25 12 9.25Z", fill: "currentColor" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_2_132" }, { children: _jsx("rect", { width: "24", height: "24", fill: "white", transform: "translate(24 24) rotate(-180)" }) })) })] })));
};
